// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".range-picker .rdrDefinedRangesWrapper {\n  display: none;\n}", "",{"version":3,"sources":["webpack://./src/styles/components/shared/atoms/DateRangePicker/dateRangePicker.scss"],"names":[],"mappings":"AACI;EACI,aAAA;AAAR","sourcesContent":[".range-picker{\n    .rdrDefinedRangesWrapper{\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
